<template>
	<header :class="appHeaderClass">
		<div class="app-header__util">
			<i
				v-if="isHistoryMenu"
				@click="$router.go(-1)"
				class="ri-arrow-left-line"
			></i>
		</div>
		<h1 class="app-header__title">{{ title }}</h1>
		<div class="app-header__util app-header__util--info">
			<i v-if="isModalMenu" @click="openModal" class="ri-information-fill"></i>
		</div>
	</header>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: '',
		},
		isHistoryMenu: {
			type: Boolean,
			default: false,
		},
		isModalMenu: {
			type: Boolean,
			default: false,
		},
		styles: {
			type: Object,
			default: () => {
				return {
					isBottomLine: true,
				};
			},
		},
	},
	computed: {
		appHeaderClass() {
			return [
				'app-header',
				{ 'app-header--bottom-line': this.styles.isBottomLine },
				'u-container',
			];
		},
	},
	methods: {
		openModal() {
			this.$store.commit('appStore/openModal');
		},
	},
};
</script>
